/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LaCapillaDelPicoGlPage } from "./la-capilla-del-pico-gl.page";

const routes: Routes = [
	{
		path: "",
		component: LaCapillaDelPicoGlPage,
	}
];
@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class LaCapillaDelPicoGlPageRoutingModule {}
